(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector(".section-header");
      this.headerIsAlwaysSticky =
        this.getAttribute("data-sticky-type") === "always" ||
        this.getAttribute("data-sticky-type") === "reduce-logo-size";
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia("(max-width: 990px)").addEventListener("change", this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add("shopify-section-header-sticky");
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector("predictive-search");

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.addEventListener("scroll", this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty("--header-height", `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
      window.removeEventListener("scroll", this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add("scrolled-past-header");
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add("scrolled-past-header");
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove("scrolled-past-header");
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
      this.closeMenuDisclosure();
      this?.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add("shopify-section-header-sticky", "animate");
      this.header.classList.remove("shopify-section-header-hidden");
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate");
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll("header-menu");
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector("details-modal");
      this.searchModal?.close(false);
    }
  }

  customElements.define("sticky-header", StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-flip-to-win"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('me-flip-to-win')) {
  customElements.define('me-flip-to-win', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('.me-flip__card')];
      this.rewards = [...this.querySelectorAll('[data-reward]')];
      this.total = Math.min(this.rewards.length, this.cards.length);
      this.count = 0;
      this.busy = false;
      this.next = this.querySelector('.me-flip__next');
      this.claim = this.querySelector('.me-flip__claim');
      this.status = this.querySelector('.me-flip__status');
      this.cards.forEach((card) => card.addEventListener('click', () => this.flip(card)));
      this.next.addEventListener('click', () => this.flip(this.cards.find(card => !card.disabled)));
      if (!this.total) { this.next.hidden = true; this.claim.hidden = false; }
    }
    flip(card) {
      if (!card || card.disabled || this.busy || this.count >= this.total) return;
      this.busy = true;
      const reward = this.rewards[this.count];
      card.querySelector('.me-flip__front').append(reward.content.cloneNode(true));
      card.classList.add('is-flipped');
      card.setAttribute('aria-pressed', 'true');
      card.setAttribute('aria-label', reward.dataset.title);
      card.disabled = true;
      this.count += 1;
      this.querySelector('[data-collected]').textContent = this.count;
      const left = this.total - this.count;
      this.status.textContent = reward.dataset.title + ' · ' + this.count + '/' + this.total;
      this.next.textContent = this.dataset.more.replace('[count]', left);
      if (left === 0) {
        this.cards.forEach(c => { c.disabled = true; if (!c.classList.contains('is-flipped')) c.classList.add('is-muted'); });
        this.next.hidden = true;
        this.claim.hidden = false;
        this.status.textContent = this.dataset.done;
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          for (let i = 0; i < 24; i++) {
            const piece = document.createElement('span');
            piece.className = 'me-flip__confetti';
            piece.setAttribute('aria-hidden', 'true');
            piece.style.setProperty('--x', (Math.random() * 600 - 300) + 'px');
            piece.style.setProperty('--y', (Math.random() * 400 + 180) + 'px');
            piece.style.setProperty('--rotate', (Math.random() * 360) + 'deg');
            this.append(piece);
            setTimeout(() => piece.remove(), 1500);
          }
        }
      }
      setTimeout(() => { this.busy = false; }, 650);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-mpc-live-header"]) return;
  try {
    
(() => {
  let observer;
  const mobile = window.matchMedia('(max-width: 989px)');
  const targetForOffer = () => document.querySelector('.me-discovery-panel') || document.querySelector('product-info variant-selects fieldset') || document.getElementById('me-choose-scent');
  const connect = () => {
    const header = document.querySelector('.me-figma-header');
    if (!header) return;
    observer?.disconnect();
    const measure = () => document.documentElement.style.setProperty('--me-sticky-header-height', `${header.getBoundingClientRect().height}px`);
    observer = new ResizeObserver(measure);
    observer.observe(header);
    measure();
    const target = targetForOffer();
    if (target) {
      if (!target.id) target.id = 'me-offer-start';
      header.querySelector('.me-figma-header__offer').setAttribute('href', `#${target.id}`);
    }
    const footer = document.querySelector('footer');
    if (footer) {
      if (!footer.id) footer.id = 'me-footer';
      header.querySelector('.me-figma-header__menu').setAttribute('href', `#${footer.id}`);
    }
    const logo = header.querySelector('.me-figma-header__logo');
    if (mobile.matches) logo.setAttribute('tabindex', '-1');
    else logo.removeAttribute('tabindex');
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.me-figma-header__offer, .me-figma-header__menu, .me-figma-header__cart');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.classList.contains('me-figma-header__cart')) {
      const drawer = document.querySelector('cart-drawer');
      if (typeof drawer?.open === 'function') {
        event.preventDefault();
        event.stopImmediatePropagation();
        drawer.open(link);
      }
      return;
    }
    const target = link.classList.contains('me-figma-header__menu') ? document.querySelector('footer') : targetForOffer();
    if (!target) return;
    event.preventDefault();
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    const offset = document.querySelector('.me-figma-header').getBoundingClientRect().height + 16;
    window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  mobile.addEventListener('change', connect);
  document.addEventListener('shopify:section:load', connect);
})();

  if (!customElements.get('me-mobile-promo')) {
    customElements.define('me-mobile-promo', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.me-promo-message'));
        this.button = this.querySelector('button');
        if (!this.slides.length || !this.button) return;
        this.mobile = matchMedia('(max-width: 749px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.index = this.paused ? Math.min(1, this.slides.length - 1) : 0;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.button.addEventListener('click', () => { this.paused = !this.paused; this.render(); this.schedule(); }, options);
        this.mobile.addEventListener('change', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { this.paused = this.motion.matches; if (this.paused) this.index = Math.min(1, this.slides.length - 1); this.render(); this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovering = true; this.stop(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, options);
        this.button.addEventListener('focus', () => { if (this.button.matches(':focus-visible')) { this.paused = true; this.render(); this.schedule(); } }, options);
        this.render();
        this.schedule();
      }
      render() {
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        const action = this.paused ? this.dataset.resume : this.dataset.pause;
        this.button.setAttribute('aria-label', `${this.slides[this.index].textContent.trim()}. ${action}`);
      }
      stop() {
        clearTimeout(this.timer);
        clearTimeout(this.fadeTimer);
        delete this.dataset.fading;
      }
      schedule() {
        this.stop();
        if (this.slides.length < 2 || this.paused || this.hovering || !this.mobile.matches || document.hidden) return;
        this.timer = setTimeout(() => {
          this.dataset.fading = '';
          this.fadeTimer = setTimeout(() => {
            this.index = (this.index + 1) % this.slides.length;
            this.render();
            this.schedule();
          }, this.motion.matches ? 0 : 250);
        }, (Number(this.dataset.seconds) || 5) * 1000);
      }
      disconnectedCallback() { this.stop(); this.controller?.abort(); }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-mpc-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('me-mpc-product')) {
  customElements.define('me-mpc-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-mpc-config]').textContent);
      this.form = this.querySelector('form');
      this.toggle = this.querySelector('[data-subscription]');
      this.planSelect = this.querySelector('[data-plan-select]');
      this.button = this.querySelector('[data-submit]');
      this.money = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.proposal ? 'EUR' : this.config.currency });
      if (this.config.proposal) this.toggle.checked = true;
      const variantId = new URLSearchParams(location.search).get('variant');
      const linkedVariant = this.config.variants.find(v => String(v.id) === variantId && /^MPC-(HF|NS)-(4|8)-SI$/.test(v.sku)) || this.config.variants.find(v => v.available && /-8-SI$/.test(v.sku)) || this.config.variants.find(v => v.available && /^MPC-(HF|NS)-(4|8)-SI$/.test(v.sku));
      if (linkedVariant) {
        const match = linkedVariant.sku.match(/^MPC-(HF|NS)-(4|8)-SI$/);
        if (match) { this.querySelector(`[data-scent-field] input[value="${match[1]}"]`).checked = true; this.querySelector(`[data-refill-field] input[value="${match[2]}"]`).checked = true; }
      }
      this.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => this.submit(event));

      this.onPageShow = event => {
        this.busy = false;
        this.update();
        if (event.persisted) this.refreshCartDrawer();
      };
      window.addEventListener('pageshow', this.onPageShow);
      this.update();
      this.initVariantGallery(linkedVariant);
      this.initGallery();
    }
    disconnectedCallback() {
      window.removeEventListener('pageshow', this.onPageShow);
    }
    async refreshCartDrawer() {
      try {
        const response = await fetch(window.location.href, { cache: 'no-store' });
        if (!response.ok) return;
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const freshDrawer = parsed.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');
        if (freshDrawer && currentDrawer) currentDrawer.replaceWith(freshDrawer);

        // Dawn's header cart count bubble; adjust selector if your theme customized it
        const freshBubble = parsed.querySelector('#cart-icon-bubble');
        const currentBubble = document.querySelector('#cart-icon-bubble');
        if (freshBubble && currentBubble) currentBubble.replaceWith(freshBubble);
        // Re-wire the drawer trigger that was attached to the removed bubble
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.setHeaderCartIconAccessibility === 'function') drawer.setHeaderCartIconAccessibility();
      } catch (e) {
        console.error('MPC cart drawer refresh failed:', e);
      }
    }
    initGallery() {
      const slides = this.querySelector('.mpc__slides');
      const pagination = this.querySelector('.mpc__pagination');
      if (!slides || !pagination) return;
      const controls = Array.from(pagination.querySelectorAll('button'));
      let active = 0;
      const goTo = index => slides.scrollTo({left: ((index + controls.length) % controls.length) * slides.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      controls.forEach((button, index) => button.addEventListener('click', () => goTo(index)));
      slides.addEventListener('scroll', () => {
        const index = Math.round(slides.scrollLeft / slides.clientWidth);
        controls.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
        if (index !== active && controls[index]) {
          const button = controls[index];
          pagination.scrollTo({left: Math.max(0, button.offsetLeft - pagination.clientWidth / 2 + button.offsetWidth / 2), behavior: 'instant'});
          active = index;
        }
      }, {passive: true});
      this.querySelector('.mpc__prev').addEventListener('click', () => goTo(active - 1));
      this.querySelector('.mpc__next').addEventListener('click', () => goTo(active + 1));
      slides.addEventListener('keydown', event => {
        if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
          event.preventDefault();
          goTo(event.key === 'Home' ? 0 : event.key === 'End' ? controls.length - 1 : active + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
    }
    initVariantGallery(variant) {
      if (!this.hasAttribute('data-variant-images')) return;
      const slides = this.querySelector('.mpc__slides');
      const pagination = this.querySelector('.mpc__pagination');
      if (!slides) return;
      const images = Array.from(slides.querySelectorAll('img[data-image-id]'));
      const buttons = Array.from(pagination?.querySelectorAll('button') || []);
      this.variantImages = new Map(images.map((image, index) => [image.dataset.imageId, { image: image.cloneNode(true), thumbnail: buttons[index]?.querySelector('img')?.cloneNode(true) }]));
      const featuredIds = new Set(this.config.variants.map(item => String(item.imageId)));
      const initial = this.variantImages.get(String(variant?.imageId)) || this.variantImages.get(images[0]?.dataset.imageId);
      if (!initial) return;
      images.forEach((image, index) => {
        const filename = (image.getAttribute('src') || '').split('/').pop().split('?')[0];
        const variantPhoto = featuredIds.has(image.dataset.imageId) || /^(MPC_Herbal_\d+|MPC_FF_\d+|MPCFF\d+|complete-starter-kit-img)\./i.test(filename);
        if (variantPhoto || image.dataset.imageId === initial.image.dataset.imageId) {
          image.remove();
          buttons[index]?.remove();
        }
      });
      const firstImage = initial.image.cloneNode(true);
      firstImage.loading = 'eager';
      slides.prepend(firstImage);
      if (pagination && buttons[0]) {
        const firstButton = buttons[0].cloneNode(true);
        if (initial.thumbnail) firstButton.replaceChildren(initial.thumbnail.cloneNode(true));
        pagination.prepend(firstButton);
        const controls = Array.from(pagination.querySelectorAll('button'));
        controls.forEach((button, index) => {
          button.setAttribute('aria-label', (this.config.galleryImageLabel || '[index] / [count]').replace('[index]', index + 1).replace('[count]', controls.length));
          button.setAttribute('aria-current', String(index === 0));
        });
      }
      slides.scrollTo({ left: 0, behavior: 'instant' });
    }
    updateVariantImage() {
      if (!this.hasAttribute('data-variant-images')) return;
      const imageId = this.variant?.imageId;
      if (!imageId || this.selectedImageId === imageId) return;
      const source = this.variantImages?.get(String(imageId));
      const slides = this.querySelector('.mpc__slides');
      if (!source || !slides?.firstElementChild) return;
      const image = source.image.cloneNode(true);
      image.loading = 'eager';
      slides.firstElementChild.replaceWith(image);
      const pagination = this.querySelector('.mpc__pagination');
      if (source.thumbnail && pagination?.firstElementChild) pagination.firstElementChild.replaceChildren(source.thumbnail.cloneNode(true));
      slides.scrollTo({ left: 0, behavior: 'instant' });
      pagination?.scrollTo({ left: 0, behavior: 'instant' });
      this.querySelectorAll('.mpc__pagination button').forEach((button, index) => button.setAttribute('aria-current', String(index === 0)));
      this.selectedImageId = imageId;
    }
    giftIncluded(key, count, subscribed = this.toggle.checked) {
      return key === 'bottle' || key === 'cloths' || (Number(count) === 8 && (key !== 'brush' || subscribed));
    }
    giftValue(count, subscribed = this.toggle.checked) {
      return ['bottle', 'cloths', 'brush', 'extra_bottle'].reduce((total, key) => total + (this.giftIncluded(key, count, subscribed) ? this.config.proposalRrp[key] * (key === 'cloths' && Number(count) === 8 ? 2 : 1) : 0), 0);
    }
    referenceValue(variant, count) { return this.config.proposal ? Number(count) / 4 * this.config.proposalRrp.refill + this.giftValue(count) : Math.max(variant?.compareAt || 0, variant?.price || 0); }
    offerPrice(variant, count, subscribed = this.toggle.checked) {
      if (this.config.proposal) return Number(count) === 4 ? subscribed ? 1995 : 2395 : subscribed ? 3495 : 3695;
      return subscribed ? variant?.allocations[0]?.price : variant?.price;
    }
    findVariant(scent, count) { return this.config.variants.find(v => v.sku === `MPC-${scent}-${count}-SI`); }
    plans(variant) { return (variant?.allocations || []).filter(p => p.recurring); }
    amount(cents) { return this.money.format(cents / 100); }
    update() {
      const scent = this.querySelector('[data-scent-field] input:checked').value;
      const count = this.querySelector('[data-refill-field] input:checked').value;
      this.variant = this.findVariant(scent, count);
      this.updateVariantImage();
      const plans = this.plans(this.variant);
      const previousPlan = this.planSelect.value;
      this.planSelect.replaceChildren(...plans.map(p => new Option(p.name, p.id)));
      if (plans.some(p => String(p.id) === previousPlan)) this.planSelect.value = previousPlan;
      this.toggle.disabled = this.config.subscriptionOnly || (!this.config.proposal && (!plans.length || !!this.variant?.requiresPlan));
      if (this.config.subscriptionOnly) this.toggle.checked = true;
      else if (!this.config.proposal) {
        if (!plans.length) this.toggle.checked = false;
        else if (this.variant?.requiresPlan) this.toggle.checked = true;
      }
      // Get the first allocation/plan instead of finding a specific plan
      const selectedAllocation = this.variant?.allocations[0];
      this.querySelector('[data-plan-options]').hidden = !selectedAllocation || plans.length < 2;
      const sellingPlanInput = this.querySelector('[data-selling-plan]');
      sellingPlanInput.disabled = !selectedAllocation || this.config.proposal;
      sellingPlanInput.value = selectedAllocation?.id || '';
      this.querySelector('[data-variant]').value = this.variant?.id || '';
      const price = this.config.proposal ? this.offerPrice(this.variant, count) : this.toggle.checked ? selectedAllocation?.price ?? (this.config.subscriptionOnly ? null : this.variant?.price) : this.variant?.price;
      this.querySelector('[data-total]').textContent = price == null ? '—' : this.amount(price);
      this.querySelector('[data-contents]').textContent = (Number(count) === 8 ? this.config.labels.completeContents : this.config.labels.contents).replace('[count]', count);
      const planNote = this.querySelector('[data-plan-note]');
      planNote.hidden = this.config.proposal || (this.config.subscriptionOnly && !plans.length);
      planNote.textContent = !plans.length ? this.config.labels.noPlans : this.toggle.checked && selectedAllocation ? selectedAllocation.name : this.config.labels.oneTime;
      this.querySelector('[data-purchase-note]').textContent = this.toggle.checked ? this.config.labels.subscriptionNote : this.config.labels.oneTime;
      if (this.config.proposal && !this.toggle.checked) this.querySelector('[data-purchase-note]').textContent = this.config.labels.previewOneTime;
      this.querySelectorAll('[data-gift-key]').forEach(card => {
        const key = card.dataset.giftKey;
        const included = this.giftIncluded(key, count);
        card.classList.toggle('is-locked', !included);
        const bottleCount = Number(count) === 8 ? 2 : 1;
        card.querySelector('[data-gift-unit]').textContent = this.amount(this.config.proposalRrp[key] * (key === 'bottle' || key === 'cloths' ? bottleCount : 1));
        if (key === 'bottle') card.querySelector('[data-gift-name]').textContent = bottleCount === 2 ? this.config.giftBottleNames.double : this.config.giftBottleNames.single;
        if (key === 'cloths') card.querySelector('[data-gift-name]').textContent = bottleCount === 2 ? this.config.giftClothNames.double : this.config.giftClothNames.single;
        card.querySelector('[data-gift-status]').textContent = included ? this.config.giftLabels.included : this.config.giftLabels.excluded;
      });
      this.querySelector('[data-gift-total]').textContent = this.config.giftLabels.total.replace('[value]', this.amount(this.giftValue(count)));
      const referencePrice = this.referenceValue(this.variant, count);
      const planPrice = this.offerPrice(this.variant, count, true);
      const savingPercent = referencePrice > 0 && planPrice != null ? Math.round((referencePrice - planPrice) / referencePrice * 100) : 0;
      this.querySelector('[data-plan-heading]').textContent = savingPercent > 0 ? this.config.labels.save.replace('[amount]', savingPercent + '%') : this.config.labels.planTitle;
      const description = this.querySelector('[data-plan-description]');
      description.hidden = !selectedAllocation?.description;
      description.innerHTML = selectedAllocation?.description || '';
      const adjustments = selectedAllocation?.adjustments || [];
      const later = adjustments[1];
      this.querySelector('[data-renewal]').textContent = this.toggle.checked && selectedAllocation ? later ? this.config.labels.renewal.replace('[count]', adjustments[0].count || 1).replace('[amount]', this.amount(later.price)) : this.config.labels.recurring.replace('[amount]', this.amount(price)) : '';
      this.querySelectorAll('[data-refill-field] input').forEach(input => {
        const variant = this.findVariant(scent, input.value);
        input.disabled = !variant?.available;
        const candidatePrice = this.offerPrice(variant, input.value);
        const label = this.querySelector(`[data-extra-price="${input.value}"]`);
        const saving = this.querySelector(`[data-bundle-saving="${input.value}"]`);
        const reference = this.referenceValue(variant, input.value);
        const compare = this.querySelector(`[data-card-compare="${input.value}"]`);
        compare.hidden = !variant?.available || candidatePrice == null || !(reference > candidatePrice);
        compare.textContent = compare.hidden ? '' : this.amount(reference);
        compare.title = this.config.proposal ? this.config.labels.valueLabel : '';
        if (saving) {
          const difference = reference - candidatePrice;
          saving.hidden = !variant?.available || !(difference > 0);
          saving.textContent = saving.hidden ? '' : this.config.labels.bundleSaving.replace('[amount]', this.amount(difference)).replace('[percent]', Math.round(difference / reference * 100));
        }
        label.textContent = !variant?.available ? this.config.labels.unavailable : candidatePrice != null ? this.amount(candidatePrice) : '—';
      });
      this.querySelectorAll('[data-scent-field] input').forEach(input => { input.disabled = !this.findVariant(input.value, count)?.available; });
      const available = this.variant?.available && (this.config.proposal || (!(this.config.subscriptionOnly || this.variant.requiresPlan) || !!selectedAllocation));
      this.button.disabled = this.config.proposal || !available || !!this.busy;
      this.querySelector('[data-cta-label]').textContent = this.busy ? this.config.labels.adding : available ? this.config.labels.cta : this.config.labels.unavailable;
      this.querySelector('[data-cta-pricing]').hidden = this.busy || !available;
      this.querySelector('[data-cta-price]').textContent = price == null ? '' : this.amount(price);
      const compare = this.querySelector('[data-cta-compare]');
      compare.hidden = !available || !(referencePrice > price);
      compare.textContent = compare.hidden ? '' : this.amount(referencePrice);
    }
    async submit(event) {
  event.preventDefault();
  if (this.config.proposal || this.busy || !this.variant?.available || this.button.disabled || (this.config.subscriptionOnly && !this.variant?.allocations[0])) return;
  this.busy = true;
  this.update();
  const error = this.querySelector('[data-error]');
  error.hidden = true;

  const count = this.querySelector('[data-refill-field] input:checked').value;
  const randomNumber = Math.floor(Date.now() / 1000) % 10000;
  const tag = `${this.variant.id}-${randomNumber}`;

  const mainItem = {
    id: this.variant.id,
    quantity: 1,
    properties: { '_is_mpc_main': tag }
  };
  const selectedAllocation = this.variant?.allocations[0];
  if (this.toggle.checked && selectedAllocation) mainItem.selling_plan = selectedAllocation.id;

  // Build add-on items based on kit size
  let addOnItems = [];
  if (Number(count) === 4) {
    addOnItems = [53067574772050, 53067756175698].map(id => ({
      id,
      quantity: 1,
      properties: { '_is_mpc_add_on': tag }
    }));
  } else if (Number(count) === 8) {
    addOnItems = [
      ...[53067574772050, 53067756175698].map(id => ({
        id,
        quantity: 2,
        properties: { '_is_mpc_add_on': tag }
      })),
      { id: 51868778234194, quantity: 1, properties: { '_is_mpc_add_on': tag } }
    ];
  }

  try {
    // Add everything in one call, but capture the full response for diagnostics
    const response = await fetch(this.config.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [mainItem, ...addOnItems],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    const result = await response.json();

    if (!response.ok || result.status) {
      // Shopify's /cart/add.js response, when it rejects an item, usually includes
      // which item failed in result.description or result.message. Log it raw.
      console.error('MPC cart/add.js rejected the request:', result);
      throw new Error(typeof result.description === 'string' ? result.description : this.config.labels.error);
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && result.sections?.['cart-drawer'] && result.sections?.['cart-icon-bubble']) {
      drawer.setActiveElement(this.button);
      drawer.renderContents(result);
    } else {
      await this.refreshCartDrawer();
      document.querySelector('cart-drawer')?.open(this.button);
    }
    this.busy = false;
    this.update();
  } catch (failure) {
    console.error('MPC add-to-cart failed:', failure);
    error.textContent = failure.message || this.config.labels.error;
    error.hidden = false;
    this.busy = false;
    this.update();
  }
}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfc-landing-header"]) return;
  try {
    
(() => {
  let observer;
  const mobile = window.matchMedia('(max-width: 989px)');
  const targetForOffer = () => document.querySelector('.me-discovery-panel') || document.querySelector('product-info variant-selects fieldset') || document.getElementById('me-choose-scent') || document.getElementById('pfc-kit');
  const connect = () => {
    const header = document.querySelector('.me-figma-header');
    if (!header) return;
    observer?.disconnect();
    const measure = () => document.documentElement.style.setProperty('--me-sticky-header-height', `${header.getBoundingClientRect().height}px`);
    observer = new ResizeObserver(measure);
    observer.observe(header);
    measure();
    const target = targetForOffer();
    if (target && header.querySelector('.me-figma-header__offer').getAttribute('href').startsWith('#')) {
      if (!target.id) target.id = 'me-offer-start';
      header.querySelector('.me-figma-header__offer').setAttribute('href', `#${target.id}`);
    }
    const logo = header.querySelector('.me-figma-header__logo');
    if (mobile.matches) logo.setAttribute('tabindex', '-1');
    else logo.removeAttribute('tabindex');
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.me-figma-header__offer, .me-figma-header__cart');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.classList.contains('me-figma-header__cart')) {
      const drawer = document.querySelector('cart-drawer');
      if (typeof drawer?.open === 'function') {
        event.preventDefault();
        event.stopImmediatePropagation();
        drawer.open(link);
      }
      return;
    }
    if (!link.getAttribute('href').startsWith('#')) return;
    const target = targetForOffer();
    if (!target) return;
    event.preventDefault();
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    const offset = document.querySelector('.me-figma-header').getBoundingClientRect().height + 16;
    window.scrollTo({ top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  mobile.addEventListener('change', connect);
  document.addEventListener('shopify:section:load', connect);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-mobile-promo')) {
    customElements.define('me-mobile-promo', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.me-promo-message'));
        this.button = this.querySelector('button');
        if (!this.slides.length || !this.button) return;
        this.mobile = matchMedia('(max-width: 749px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.index = this.paused ? Math.min(1, this.slides.length - 1) : 0;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.button.addEventListener('click', () => { this.paused = !this.paused; this.render(); this.schedule(); }, options);
        this.mobile.addEventListener('change', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { this.paused = this.motion.matches; if (this.paused) this.index = Math.min(1, this.slides.length - 1); this.render(); this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovering = true; this.stop(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, options);
        this.button.addEventListener('focus', () => { if (this.button.matches(':focus-visible')) { this.paused = true; this.render(); this.schedule(); } }, options);
        this.render();
        this.schedule();
      }
      render() {
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        const action = this.paused ? this.dataset.resume : this.dataset.pause;
        this.button.setAttribute('aria-label', `${this.slides[this.index].textContent.trim()}. ${action}`);
      }
      stop() {
        clearTimeout(this.timer);
        clearTimeout(this.fadeTimer);
        delete this.dataset.fading;
      }
      schedule() {
        this.stop();
        if (this.slides.length < 2 || this.paused || this.hovering || !this.mobile.matches || document.hidden) return;
        this.timer = setTimeout(() => {
          this.dataset.fading = '';
          this.fadeTimer = setTimeout(() => {
            this.index = (this.index + 1) % this.slides.length;
            this.render();
            this.schedule();
          }, this.motion.matches ? 0 : 250);
        }, (Number(this.dataset.seconds) || 5) * 1000);
      }
      disconnectedCallback() { this.stop(); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
